import { useCallback, useEffect, useRef, useState } from "react";
import { Toast } from "../../components/ui/Toast";

/** The prototype's toast: one short note at a time, gone after a few seconds. A failure shows without the check mark. */
export function useToast() {
  const [t, setT] = useState({ message: "", on: false, done: true });
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  const say = useCallback((message: string, done = true) => {
    setT({ message, on: true, done });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setT((x) => ({ ...x, on: false })), 2900);
  }, []);
  return { toast: <Toast message={t.message} on={t.on} done={t.done} />, say };
}
